import { Button, DialogActions, DialogContent } from "@material-ui/core";
import { LoadedFile } from "../types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, List } from "@material-ui/core";
import AccountItem from "./AccountItem";
import { ShowMoreContainer } from "./styled";

type Params = {
  selectedFile: LoadedFile;
  back: () => void;
  columns?: string[];
};

export default function AccountsView({ selectedFile, back, columns }: Params) {
  const { t } = useTranslation("accounts");
  const [listItems, setListItems] = useState(20);
  const { fileName, items } = selectedFile;
  return (
    <>
      <DialogContent>
        {columns && (
          <Typography variant="body2" style={{ marginBottom: "10px" }}>
            {t("modal.account.updateHint", { columns: columns.join(", ") })}
          </Typography>
        )}
        <List>
          <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
            {t("importAccountsModal.filename", { name: fileName })}
          </Typography>
          {items.slice(0, listItems).map((account, i) => (
            <AccountItem item={account} key={i} />
          ))}
          {items.length > listItems && (
            <ShowMoreContainer>
              <Button
                variant="contained"
                size="small"
                color="primary"
                disableElevation
                onClick={() => setListItems(prev => prev + 10)}
              >
                {t("importAccountsModal.accounts.showMoreBtn")}
              </Button>
            </ShowMoreContainer>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" size="small" onClick={back}>
          {t("importAccountsModal.goBackBtn")}
        </Button>
      </DialogActions>
    </>
  );
}
